import PatientInit from "../patientInit/PatientInit";
import Patient from "../patient/Patient";
import Drugs from "../drugs/Drugs";
import Pgx from "../pgx/PGx";
import Diary from "../diary/Diary";
import Symptoms from "../symptoms/Symptoms";
import Measurements from "../measurements/Measurements";
import LabTests from "../labTests/LabTests";
import Patients from "../patients/Patients";
import Page404 from "../pages/404";
import AppHeader from "../appHeader/AppHeader";
import AppFooter from "../appFooter/AppFooter";

const _apiBase = "https://safepolymed-mmc.fraunhofer.de/api/";
const _apiBase1 = "https://localhost:7071/api/";

export {
  PatientInit,
  Patient,
  Pgx,
  Drugs,
  Diary,
  Symptoms,
  Measurements,
  LabTests,
  Patients,
  Page404,
  AppHeader,
  AppFooter,
  _apiBase,
};
